<template>
  <div>
    <v-layout class="mt-5 mb-2">
      <v-flex xs4 sm3 lg2 class="mr-3 ">
        <v-select
          v-model="buscarSelect"
          :items="buscaOptions"
          label="Tipo de busca"
          outlined
          menu-props="offsetY"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
          @change="onChangeBuscaOptions"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm9 lg6>
        <v-autocomplete
          v-model="searchSelected"
          :items="buscaTiposCardapio"
          :hide-no-data="!search && buscaTiposCardapio.length == 0 && !buscarLoading"
          :no-data-text="buscarLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${search}'`"
          outlined
          label="Buscar por"
          placeholder="Digite um valor para buscar"
          prepend-inner-icon="search"
          :search-input.sync="search"
          :filter="filtrarBusca"
          @keydown="buscar()"
          :loading="buscarLoading"
          @change="encontrado"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
        ></v-autocomplete>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadortitulocardapio"
      :novo="novoCardapio"
      :editar="editarCardapio"
      :excluir="excluirCardapio"
      :cancelar="cancelarCardapio"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaCardapio">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text>
          <v-row no-gutters>
            <v-col lg="7">
              <v-text-field label="Código do Cardápio" v-model="form.identificadortitulocardapio" outlined disabled background-color="#f2f2f2"></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7" class="mb-sm-5">
              <Validate :v="$v.form.descricaotitulocardapio">
                <v-text-field
                  slot-scope="{ props }"
                  v-bind="props"
                  label="Título do Cardápio*"
                  v-model="form.descricaotitulocardapio"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  outlined>
                </v-text-field>
              </Validate>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const TituloCardapioRepository = RepositoryFactory.get("tituloCardapio");

const setFormInicial = () => ({
  identificadortitulocardapio: '',
  descricaotitulocardapio: '',
});

export default {
  name: 'TipoCardapio',

  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      loading: false,
      buscarSelect: 'descricaotitulocardapio',
      buscaOptions: [
        { value: 'identificadortitulocardapio', text: 'Código' },
        { value: 'descricaotitulocardapio', text: 'Descrição' },
      ],
      formUltimo: {},
      searchSelected: '',
      buscaTiposCardapio: [],
      buscarLoading : false,
      search: '',
      filtrarBusca: this.filtrarBuscaDescricao,
    };
  },

  validations: {
    form: {
      descricaotitulocardapio: { required, maxLength: maxLength(100) },
    }
  },

  mounted() {
    this.$Progress.finish();
  },

  computed: {
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir' || this.isFormLoading
    },
    isFormLoading() {
      return this.loading
    },
  },

  methods: {
    tabelaCardapio() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Tipo de Cardápio / Listar',
          rota_api: 'merenda/titulo-cardapio/tabela',
          headers: [{ text: 'Identificador', value: 'identificadortitulocardapio', sortable: false },
          { text: 'Título', value: 'descricaotitulocardapio', sortable: false }],
        },
      });
    },
    novoCardapio() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
    },
    editarCardapio() {
      this.acao = 'editar';
    },
    cancelarCardapio() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
      this.loading = false;
    },
    async excluirCardapio() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este cardápio?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          this.loading = true;
          const { data } = await TituloCardapioRepository.deletarCardapio(this.form.identificadortitulocardapio);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
          this.buscaTiposCardapio = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
      this.loading = false;
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.loading = true;
      this.msgArrayError = []

      try {
        const { data } = await TituloCardapioRepository[this.acao === 'novo' ? 'criarCardapio' : 'editarCardapio'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };
        this.$v.$reset();
        this.buscaTiposCardapio = [];
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },

    encontrado(dados) {
      this.form = setFormInicial();
      let dado = this.buscaTiposCardapio.find(e => e.value == dados);
      this.form = { identificadortitulocardapio: dado.value, descricaotitulocardapio: dado.text };
      this.formUltimo = { ...this.form };
      this.$nextTick(() => {
        this.searchSelected = null;
        this.search = '';
      });
      this.acao = '';
    },

    onChangeBuscaOptions(option) {
      if (option == 'identificadortitulocardapio') this.filtrarBusca = this.filtrarBuscaCodigo
      else if (option == 'descricaotitulocardapio') this.filtrarBusca = this.filtrarBuscaDescricao
    },

    filtrarBuscaCodigo(item, queryText, itemText) {
      return item.value == queryText
    },

    filtrarBuscaDescricao(item, queryText, itemText) {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },

    async buscar() {
      if (this.buscaTiposCardapio.length || this.buscarLoading) return
      this.buscarLoading = true

      const { data } = await TituloCardapioRepository.buscarCardapios();
      for (const key of data.results) {
        this.buscaTiposCardapio.push({ value: key.identificadortitulocardapio, text: key.descricaotitulocardapio })
      }

      this.buscarLoading = false
    },
  },
};
</script>

<style></style>
